/**
 * Trash button that removes a whole cart drawer line item.
 *
 * Instead of calling /cart/change.js itself, it sets the stepper input to 0 and dispatches "change", exactly like the
 * stepper's minus button does at quantity 1. The theme's <line-item-quantity> then handles the request, loader,
 * removal animation, error message and drawer refresh, so both paths stay in sync.
 */
class LineItemRemoveButton extends HTMLElement {
	connectedCallback() {
		this.button = this.querySelector('button');
		this.quantityInput = this.closest('line-item-quantity')?.querySelector('.quantity-input');
		this.lineItem = this.closest('line-item');

		if (!this.button || !this.quantityInput) {
			return;
		}

		this.isRemoving = false;
		this.abortController = new AbortController();
		const { signal } = this.abortController;

		this.button.addEventListener('click', this.removeLineItem.bind(this), { signal });
		this.lineItem?.addEventListener('line-item:error', this.handleRemoveError.bind(this), { signal });
	}

	disconnectedCallback() {
		this.abortController?.abort();
	}

	removeLineItem() {
		if (this.isRemoving) {
			return;
		}

		this.isRemoving = true;
		this.quantityInput.value = '0';
		this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
	}

	handleRemoveError() {
		this.isRemoving = false;
	}
}

if (!window.customElements.get('line-item-remove-button')) {
	window.customElements.define('line-item-remove-button', LineItemRemoveButton);
}
